module.exports = __webpack_public_path__ + "img/services_face.ce92de9.png";